// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7955cf63","821":"16afa570","977":"cb47c59e"}[chunkId] + ".chunk.js";
};